<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidades"
                            @change="handleUnidadeChange"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.infraestruturas"
                            @change="handleInfraestruturaChange"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.usuarios"
                            :validations="validations.usuario"
                            @change="handleUsuarioChange"
                            default-option-text="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.turnos"
                            @change="handleTurnoChange"
                            default-option-text="Todos"
                            label="Turno"
                            show-default-option
                            text-field="descricao"
                            v-model="model.turnoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.ocupacoes"
                            @change="handleOcupacaoChange"
                            default-option-text="Todos"
                            label="CBO"
                            show-default-option
                            text-field="nome"
                            v-model="model.ocupacaoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.equipes"
                            @change="handleEquipeChange"
                            default-option-text="Todas"
                            label="Equipe"
                            show-default-option
                            text-field="descricao"
                            v-model="model.equipeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.modalidades"
                            @change="handleModalidadeChange"
                            default-option-text="Todas"
                            label="Modalidade"
                            show-default-option
                            text-field="descricao"
                            v-model="model.modalidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <template v-if="data && data.itens.length > 0">
            <rkm-area
                no-margin-top
                title="Resultado"
            >
                <template v-slot:trailing>
                    <rkm-dropdown
                        class="mr-2"
                        color="primary"
                        cols="1"
                        menu-class="auto-scroll"
                        no-caret
                        small
                        title="Colunas"
                        v-rkm-tooltip.hover
                    >
                        <template v-slot:button-content>
                            <rkm-icon icon="columns" />
                        </template>

                        <rkm-form-checkbox
                            :indeterminate="indeterminate"
                            @change="selectAll"
                            class="mx-2"
                            v-model="selectedAll"
                        >
                            Todas
                        </rkm-form-checkbox>

                        <rkm-form-checkbox-group
                            :options="optionalColumns"
                            class="mx-2"
                            stacked
                            text-field="label"
                            v-model="selectedCols"
                            value-field="key"
                        />
                    </rkm-dropdown>

                    <rkm-button
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        @click="exportTo"
                        color="info"
                        small
                        title="Exportar"
                    >
                        <rkm-icon icon="file-export" />
                    </rkm-button>
                </template>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-table
                            :fields="fields"
                            :items="data.itens"
                            :sort-by="sortBy"
                            :sort-desc="sortDesc"
                            :tbody-tr-class="rowClass"
                            @sort-changed="onSortChanged"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                no-margin-top
                title="Totais"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.totalAtendimentos"
                            disabled
                            label="Total de atendimentos"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.totalPacientesAtendidos"
                            disabled
                            label="Total de pacientes atendidos"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.totalModalidades.AD1"
                            disabled
                            label="Total de atendimentos AD 1"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.totalModalidades.AD2"
                            disabled
                            label="Total de atendimentos AD 2"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :value="data.totalizadores.totalModalidades.AD3"
                            disabled
                            label="Total de atendimentos AD 3"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </template>
    </div>
</template>

<script>
// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                periodo: {required: true},
            }
        },
        fields() {
            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        optionalColumns() {
            return this.columns.filter(c => !(c.fixed || false))
        },
    },
    created() {
        this.repositories = {
            exportacao: this.getConectaSusRepository('exportacao.atencaoBasica'),
            impressao: this.getConectaSusRepository('impressao.atencaoBasica'),
            relatorioAtendimentoDomiciliar: this.getConectaSusRepository('atencaoBasica.relatorioAtendimentoDomiciliar'),
        }

        this.load()
    },
    data() {
        return {
            columns: [
                {key: 'dataAtendimento', label: 'Data de Atendimento', sortable: true},
                {key: 'pacienteNome', label: 'Nome do paciente', sortable: true},
                {key: 'pacienteSexo', label: 'Sexo do paciente', sortable: true},
                {key: 'pacienteIdade', label: 'Idade do paciente', sortable: true},
                {key: 'modalidadeDescricao', label: 'Modalidade', sortable: true},
                {key: 'usuarioNome', label: 'Profissional', sortable: true},
                {key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
                {key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true},
                {key: 'equipeDescricao', label: 'Equipe', sortable: true},
                {key: 'pacienteDataNascimento', label: 'Data de nascimento do paciente', sortable: true},
                {key: 'ocupacaoCodigo', label: 'Código do CBO', sortable: true},
                {key: 'ocupacaoNome', label: 'Descrição do CBO', sortable: true},
                {key: 'avaliacaoElegibilidade', label: 'Avaliação de elegibilidade', sortable: true},
                {key: 'dataUltimaAtualizacaoCadastroPaciente', label: 'Última atualização cadastral', sortable: true},
                {key: 'quantidadeDiasCadastroPacienteDesatualizado', label: 'Dias desatualizados', sortable: true},
            ],
            form: null,
            indeterminate: true,
            data: null,
            model: null,
            others: {moment},
            selectedAll: false,
            selectedCols: [
                'dataAtendimento',
                'pacienteNome',
                'pacienteSexo',
                'pacienteIdade',
                'modalidadeDescricao',
                'usuarioNome',
                'unidadeNomeFantasia',
                'infraestruturaNome',
                'equipeDescricao',
            ],
            sortBy: 'dataAtendimento',
            sortDesc: false,
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioAtendimentoDomiciliar.create()
                .then((response) => {
                    this.form = response.data.form
                    this.model = response.data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                turnoId: this.model.turnoId,
                ocupacaoId: this.model.ocupacaoId,
                equipeId: this.model.equipeId,
                modalidadeId: this.model.modalidadeId,
                sortBy: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                sortDesc: this.sortDesc,
            }

            this.setLoading()

            this.repositories.relatorioAtendimentoDomiciliar.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.data = Object.assign(response.data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.usuarios = []
            this.form.turnos = []
            this.form.ocupacoes = []
            this.form.equipes = []
            this.form.modalidades = []
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.usuarioId = null
            this.model.turnoId = null
            this.model.ocupacaoId = null
            this.model.equipeId = null
            this.model.modalidadeId = null
            this.data = null

            this.model.periodo = {
                start: null,
                end: null,
            }

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        print() {
            this.setLoading()

            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                turnoId: this.model.turnoId,
                ocupacaoId: this.model.ocupacaoId,
                equipeId: this.model.equipeId,
                modalidadeId: this.model.modalidadeId,
                sortBy: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                sortDesc: this.sortDesc,
                columns: this.fields.map(f => ({
                    key: this.camelToSnake(f.key),
                    label: f.label,
                    class: f.class,
                })),
            }

            this.repositories.impressao.relatorioAtendimentoDomiciliar(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()

            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                turnoId: this.model.turnoId,
                ocupacaoId: this.model.ocupacaoId,
                equipeId: this.model.equipeId,
                modalidadeId: this.model.modalidadeId,
                sortBy: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                sortDesc: this.sortDesc,
                columns: this.fields.map(f => ({
                    key: this.camelToSnake(f.key),
                    label: f.label,
                    class: f.class,
                })),
            }

            this.repositories.exportacao.relatorioAtendimentoDomiciliar(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.usuarios = []
            this.form.turnos = []
            this.form.ocupacoes = []
            this.form.equipes = []
            this.form.modalidades = []
            this.model.infraestruturaId = null
            this.model.usuarioId = null
            this.model.turnoId = null
            this.model.ocupacaoId = null
            this.model.equipeId = null
            this.model.modalidadeId = null
            this.data = null

            const request = {
                listar: 'infraestruturas',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.relatorioAtendimentoDomiciliar.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.turnos = Object.assign(response.data.turnos)
                    this.form.ocupacoes = Object.assign(response.data.ocupacoes)
                    this.form.equipes = Object.assign(response.data.equipes)
                    this.form.modalidades = Object.assign(response.data.modalidades)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInfraestruturaChange(value) {
            this.form.usuarios = []
            this.form.turnos = []
            this.form.ocupacoes = []
            this.form.equipes = []
            this.form.modalidades = []
            this.model.usuarioId = null
            this.model.turnoId = null
            this.model.ocupacaoId = null
            this.model.equipeId = null
            this.model.modalidadeId = null
            this.data = null

            const request = {
                listar: 'usuarios',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: value,
            }

            this.setLoading()

            this.repositories.relatorioAtendimentoDomiciliar.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.turnos = Object.assign(response.data.turnos)
                    this.form.ocupacoes = Object.assign(response.data.ocupacoes)
                    this.form.equipes = Object.assign(response.data.equipes)
                    this.form.modalidades = Object.assign(response.data.modalidades)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUsuarioChange(value) {
            this.form.turnos = []
            this.form.ocupacoes = []
            this.form.equipes = []
            this.form.modalidades = []
            this.model.turnoId = null
            this.model.ocupacaoId = null
            this.model.equipeId = null
            this.model.modalidadeId = null
            this.data = null

            const request = {
                listar: 'turnos',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: value,
            }

            this.setLoading()

            this.repositories.relatorioAtendimentoDomiciliar.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.turnos = Object.assign(response.data.turnos)
                    this.form.ocupacoes = Object.assign(response.data.ocupacoes)
                    this.form.equipes = Object.assign(response.data.equipes)
                    this.form.modalidades = Object.assign(response.data.modalidades)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleTurnoChange(value) {
            this.form.ocupacoes = []
            this.form.equipes = []
            this.form.modalidades = []
            this.model.ocupacaoId = null
            this.model.equipeId = null
            this.model.modalidadeId = null
            this.data = null

            const request = {
                listar: 'ocupacoes',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                turnoId: value,
            }

            this.setLoading()

            this.repositories.relatorioAtendimentoDomiciliar.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.ocupacoes = Object.assign(response.data.ocupacoes)
                    this.form.equipes = Object.assign(response.data.equipes)
                    this.form.modalidades = Object.assign(response.data.modalidades)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleOcupacaoChange(value) {
            this.form.equipes = []
            this.form.modalidades = []
            this.model.equipeId = null
            this.model.modalidadeId = null
            this.data = null

            const request = {
                listar: 'equipes',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                turnoId: this.model.turnoId,
                ocupacaoId: value,
            }

            this.setLoading()

            this.repositories.relatorioAtendimentoDomiciliar.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.equipes = Object.assign(response.data.equipes)
                    this.form.modalidades = Object.assign(response.data.modalidades)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleEquipeChange(value) {
            this.form.modalidades = []
            this.model.modalidadeId = null
            this.data = null

            const request = {
                listar: 'modalidades',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                turnoId: this.model.turnoId,
                ocupacaoId: this.model.ocupacaoId,
                equipeId: value,
            }

            this.setLoading()

            this.repositories.relatorioAtendimentoDomiciliar.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.modalidades = Object.assign(response.data.modalidades))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleModalidadeChange() {
            this.data = null
        },
        onSortChanged(context) {
            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
        selectAll(selected) {
            this.selectedCols = selected ? this.optionalColumns.map(c => c.key) : []
        },
        rowClass(item, type) {
            if (type === 'row' && item && (item.quantidadeDiasCadastroPacienteDesatualizado > 0 || item.avaliacaoElegibilidade === 'Não')) {
                return 'table-danger'
            }
        },
    },
    mixins: [error, file, repository, stringCase],
    watch: {
        'model.periodo': {
            deep: true,
            handler(value) {
                this.form.unidades = []
                this.form.infraestruturas = []
                this.form.usuarios = []
                this.form.turnos = []
                this.form.ocupacoes = []
                this.form.equipes = []
                this.form.modalidades = []
                this.model.unidadeId = null
                this.model.infraestruturaId = null
                this.model.usuarioId = null
                this.model.turnoId = null
                this.model.ocupacaoId = null
                this.model.equipeId = null
                this.model.modalidadeId = null
                this.data = null

                if (value.start === null || value.end === null)  {
                    return
                }

                const request = {
                    listar: 'unidades',
                    periodo: {
                        start: this.others.moment(value.start).format('DD/MM/YYYY'),
                        end: this.others.moment(value.end).format('DD/MM/YYYY'),
                    },
                }

                this.setLoading()

                this.repositories.relatorioAtendimentoDomiciliar.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.unidades = Object.assign(response.data.unidades)
                        this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                        this.form.usuarios = Object.assign(response.data.usuarios)
                        this.form.turnos = Object.assign(response.data.turnos)
                        this.form.ocupacoes = Object.assign(response.data.ocupacoes)
                        this.form.equipes = Object.assign(response.data.equipes)
                        this.form.modalidades = Object.assign(response.data.modalidades)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            },
        },
    },
}
</script>